import { format, startOfWeek, endOfWeek } from 'date-fns'

export default {
    filters: setInitialFilters(),
    setInitialFilters: setInitialFilters,
    weeklySentOrdersFilters: setInitialWeeklySentOrdersFilters(),
    setInitialWeeklySentOrdersFilters: setInitialWeeklySentOrdersFilters,
    monthlySentOrdersFilters: setInitialMonthlySentOrdersFilters(),
    setInitialMonthlySentOrdersFilters: setInitialMonthlySentOrdersFilters,
    products: [],
}

function setInitialFilters() {
    return {
        date: format(new Date(), 'YYYY-MM-DD'),
        reportType_name: 'godzinowy',
        date__gte: format(new Date(), 'YYYY-MM-DD'),
        date__lte: format(new Date().setDate(new Date().getDate() + 1), 'YYYY-MM-DD'),
        product_id: null
    }
}

function setInitialWeeklySentOrdersFilters() {
    return {
        date__gte: endOfWeek(new Date(), {weekStartsOn: 1}),
        date__lte: startOfWeek(new Date(), {weekStartsOn: 1})
    }
}

function setInitialMonthlySentOrdersFilters() {
    return {
        date__gte: format(new Date(new Date().getFullYear(), new Date().getMonth(), 1), 'YYYY-MM-DD'),
        date__lte: null,
    }
}
